/**
 * O menu sai inteiro dos modulos.
 *
 * Cada `resources/modules/<nome>/routes.js` exporta `nav` ao lado das rotas;
 * este arquivo so os coleta. Nao ha `legacyNavConfig` aqui -- o deck nasceu
 * com o desenho de modulos, e manter o merge seria carregar um arquivo que so
 * existe para estar vazio.
 *
 * E o UNICO arquivo do projeto com `import.meta.glob`, que e do Vite. Toda a
 * logica de montar menu vive em navFromModules.js e menuDosModulos.js, que
 * rodam sob `node --test` sem bundler -- e e por isso que sao testados.
 */
import { navDosModulos, navsDosModulos, modulosDeclarados } from './navFromModules.js';

const modulos = import.meta.glob('@/modules/*/routes.js', { eager: true });

export const navConfig = navDosModulos(modulos);

/** Declaracoes cruas, consumidas pelo montarMenu(). */
export const navsDeclarados = navsDosModulos(modulos);

/** Usado pelo menu de reserva -- ver modulosDeclarados(). */
export const navDeReserva = modulosDeclarados(modulos);
